module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAXCAYAAADQpsWBAAAA00lEQVQ4T53Uuw3CMBAG4P8iwRBU0AAtCyCFBliBQWjoeUzALAQJRMcI1CAeJVUqbCMjbEHi2Je4tT7d2feg22beFVG0FkJMmqPZHYxDl2R5AKEPhZOQYsCBdE5WDSK1B9DW8FWL4lY8ffgCkr4sCz+oLLSoDPxDXJhDHOhEIViIfNCLHDCVhGEQaXjdLnpS0RGEOoBnEH0LvwPQgUKqFMacNxlgezP0ezmg0/XVyQmcKPMG57i4eq8wgmnubJcHgU2Pk9LvUJrJZUWw6VXaEVW20RtLSNvua63lhAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mine/more.png
// module id = 00rf
// module chunks = 7